import ApiClient from 'api-client/ApiClient'
import store from 'app/store'
import ActionsSet from 'core/actions/ActionsSet'
import ListAction from 'core/actions/ListAction'
import UpdateAction from 'core/actions/UpdateAction'
import { cacheStoreKey } from 'core/caching/cacheReducers'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'

const { capi } = ApiClient.getInstance()

const getClusters = () => {
  const state = store.getState()
  const clusters = state[cacheStoreKey]?.cachedData?.[DataKeys.KaapiClusters]?.flatMap(
    (cluster) => cluster?.metadata?.name,
  )
  return clusters || []
}

export const kaapiNodesActions = ActionsSet.make<DataKeys.KaapiNodes>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiNodes],
  cacheKey: DataKeys.KaapiNodes,
})

export const listKaapiNodes = kaapiNodesActions.add(
  new ListAction<DataKeys.KaapiNodes>(async ({ endpoint }) => {
    Bugsnag.leaveBreadcrumb('Attempting to get Kaapi Nodes ')
    return capi.getAllWorkerNodes()
  }).addDependency(DataKeys.KaapiNodes),
)

export const patchKaapiNode = kaapiNodesActions.add(
  new UpdateAction<DataKeys.KaapiNodes, { name: string; body: any }>(async ({ name, body }) => {
    Bugsnag.leaveBreadcrumb('Attempting to patch Kaapi Node', { name, body })
    await capi.patchWorkerNode(name, body)
  }),
)

export const kaapiMetricsNodesActions = ActionsSet.make<DataKeys.KaapiMetricsNodes>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiMetricsNodes],
  cacheKey: DataKeys.KaapiMetricsNodes,
})
export const listKaapiMetricsNodes = kaapiMetricsNodesActions.add(
  new ListAction<DataKeys.KaapiMetricsNodes>(async () => {
    Bugsnag.leaveBreadcrumb('Attempting to get Kaapi Metrics Nodes ')
    return capi.getAllMetricsWorkerNodes()
  }).addDependency(DataKeys.KaapiMetricsNodes),
)

// Fetch worker nodes for all clusters
export const kaapiNodesActionsForAllClusters = ActionsSet.make<DataKeys.KaapiNodesAllClusters>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiNodesAllClusters],
  cacheKey: DataKeys.KaapiNodesAllClusters,
})

export const listKaapiNodesForAllClusters = kaapiNodesActionsForAllClusters.add(
  new ListAction<DataKeys.KaapiNodesAllClusters>(async () => {
    const clusters = getClusters()
    if (clusters?.length > 0) {
      Bugsnag.leaveBreadcrumb('Attempting to get Kaapi Nodes ')
      return capi.getWorkerNodesForAllClusters(clusters as string[])
    }
    return new Promise((resolve) => resolve([]))
  }),
)

export const kaapiMetricsNodesActionsForAllClusters = ActionsSet.make<
  DataKeys.KaapiMetricsNodesAllClusters
>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiMetricsNodesAllClusters],
  cacheKey: DataKeys.KaapiMetricsNodesAllClusters,
})

export const listKaapiMetricsNodesForAllClusters = kaapiMetricsNodesActionsForAllClusters.add(
  new ListAction<DataKeys.KaapiMetricsNodesAllClusters>(async () => {
    const clusters = getClusters()
    if (clusters?.length > 0) {
      Bugsnag.leaveBreadcrumb('Attempting to get Kaapi Metrics Nodes ')
      return capi.getMetricsWorkerNodesForAllClusters(clusters as string[])
    }
    return new Promise((resolve) => resolve([]))
  }),
)
